import React from "react";
import { CACHE_CONTEXT, CACHE_CONTEXT_DEVICE } from "src/constants/actionCache";
import DeployCache, {
  isShowCache,
} from "src/components/deployCache/DeployCache";
import { useState } from "react";
import ShowCacheFLFContext from "../ShowCache/ShowCacheFLFContext";
import FLFContextPopup from "../Popup/FLFContextPopup";

const FLFContextControlPanel = ({
  children,
  currentActionCache,
  recordForEdit,
  openPopup,
  setOpenPopup,
  handleOpenPopup,
  addOrEdit,
  errorsForm,
}) => {
  const [disableButton, setDisableButton] = useState(false);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
      <div>
        <DeployCache
          title="Cache Context"
          isShowButton={
            isShowCache(currentActionCache, CACHE_CONTEXT) ||
            isShowCache(currentActionCache, CACHE_CONTEXT_DEVICE)
          }
        >
          <ShowCacheFLFContext
            disableButton={disableButton}
            setDisableButton={setDisableButton}
          />
        </DeployCache>

        <FLFContextPopup
          recordForEdit={recordForEdit}
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
          handleOpenPopup={handleOpenPopup}
          addOrEdit={addOrEdit}
          errorsForm={errorsForm}
        />
      </div>
    </div>
  );
};

export default FLFContextControlPanel;
